import type { ReactElement } from 'react';
import { PageHeading } from './page-heading';

interface ComingSoonNoticeProps {
  /** 페이지 제목(h1). */
  readonly title: string;
}

/** 페이지 전체 준비중 안내 — 제목과 고정 안내 문구. */
export const ComingSoonNotice = ({ title }: ComingSoonNoticeProps): ReactElement => (
  <section className="flex flex-col items-center py-24 text-center">
    <PageHeading
      className="items-center text-center"
      title={title}
      description="페이지 준비 중입니다. 조금만 기다려 주세요."
    />
  </section>
);
